import {breadcrumbSubTitle, breadcrumbTitle} from "constance/constance.breadcrumb"

export const getTitleByPath = (location: string) => {
  return breadcrumbTitle[location] ?? 'none'
}

export const getSubTitleByPath = (location: string) => {
  return breadcrumbSubTitle[location] ?? 'none'
}
